import React from 'react';
import "./WhatsappButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WhatsappButton = () => {
    
    const phoneNumber = "51949230744";
    const message = "Hola, quisiera más información sobre sus productos...";
    
    return (    
        <a 
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target='_blank'
        rel='noopener noreferrer'
        className='whatsapp-button'
        >
             <FontAwesomeIcon fontSize={30} icon={faWhatsapp} className='whatsApp-icon' />
        </a>
    );
}

export default WhatsappButton;
